<!--
 * @Author: lwk
 * @Date: 2024-02-22 11:24:49
 * @LastEditors: lwk
 * @LastEditTime: 2024-02-29 14:03:36
 * @Description: 请填写简介
-->
<template>
  <div id="app">
    <el-breadcrumb separator="/" style="margin-bottom: 10px;">
      <el-breadcrumb-item>日行一善</el-breadcrumb-item>
      <el-breadcrumb-item>全部帖子</el-breadcrumb-item>
      <el-breadcrumb-item>帖子详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div @click="goback" style="cursor: pointer;"> {{ '<'+'返回' }}</div>
    <div class="post-item">
      <h3>{{ posts.logTitle }}</h3>
      <div class="authorTime">
        <span style="margin-right: 10px;">{{ posts.logName }}</span>
        <span>{{ posts.logTimeLong }}</span>
      </div>
      <p style="font-size: 13px;">{{ posts.logDate }}</p>
      <div class="comment_footer_detail">
        <p style="display: flex;align-items: center;" @click.stop="clickOn(posts)">
          <svg style="cursor: pointer;" t="1708585254534" class="icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="14860" width="16" height="16">
            <path
              d="M961.810101 530.773333c-4.046869-23.143434-13.291313-44.476768-27.500606-63.405252s-32.116364-33.758384-53.242828-44.07596c-20.130909-9.839192-42.653737-15.049697-65.11192-15.049697H668.651313c23.04-77.847273 33.82303-145.868283 32.051717-202.330505-1.499798-48.109899-12.06303-88.13899-31.379394-118.949495-32.465455-51.768889-77.963636-59.254949-79.877171-59.552323l-0.698182-0.103434h-0.711111c-29.375354 0-49.777778 8.300606-60.651313 24.656161-9.179798 13.808485-9.347879 30.034747-9.464243 40.766061-0.038788 3.025455-0.064646 5.882828-0.310303 7.576566l-0.090505 0.646464v0.659394c0 143.269495-148.984242 262.050909-213.268687 306.618182H103.511919c-24.268283 0-44.011313 19.74303-44.011313 44.011313v500.596364c0 24.268283 19.74303 44.011313 44.011313 44.011313h651.89495c17.170101 0 33.525657-5.456162 47.308283-15.786667 13.653333-10.265859 23.40202-24.332929 28.198787-40.688485l127.030303-342.199596 0.219798-0.646464c6.244848-21.57899 7.511919-44.670707 3.646061-66.75394zM97.603232 952.837172V452.253737c0-3.206465 2.702222-5.908687 5.908687-5.908686H266.395152v512.400808H103.511919c-3.206465 0-5.908687-2.702222-5.908687-5.908687z m824.216566-366.868687l-126.642424 341.152323c-0.310303 0.840404-0.594747 1.693737-0.853334 2.547071-2.495354 8.533333-7.382626 15.566869-14.506666 20.932525-7.227475 5.404444-15.450505 8.145455-24.423435 8.145455H304.497778V446.332121c7.667071-0.051717 15.140202-2.404848 21.449697-6.774949 68.809697-47.696162 228.538182-175.696162 229.66303-336.226263 0.323232-3.348687 0.36202-6.684444 0.400808-10.188283 0.064646-6.619798 0.168081-15.683232 3.10303-20.092121 2.92202-4.39596 12.774141-7.240404 26.039596-7.602424 7.059394 1.848889 32.219798 10.382222 51.885253 41.761616 15.683232 25.005253 24.281212 58.608485 25.574141 99.878788 1.64202 52.363636-8.636768 116.402424-30.500202 190.332121a38.11297 38.11297 0 0 0 5.999192 33.616162 38.111677 38.111677 0 0 0 30.526061 15.295353h147.303434c16.691717 0 33.422222 3.865859 48.381414 11.183839 15.657374 7.654141 28.948687 18.65697 39.49899 32.711111 10.576162 14.08 17.454545 29.918384 20.441212 47.075555a110.541576 110.541576 0 0 1-2.443636 48.665859z m0 0"
              p-id="14861" :fill="posts.commentType == 1 ?  '#1296db':'#8a8a8a' "></path>
          </svg>
          <span class="goodNum">{{ posts.likeNum }}</span>
        </p>
        <p style="display: flex;align-items: center;" @click.stop="clickDown">
          <svg style="cursor: pointer;" t="1708584448085" class="icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="11073" width="16" height="16">
            <path
              d="M541.37472 1023.07456c-53.2608 0-78.1888-29.0944-89.7216-53.50528-13.23776-28.01664-13.23776-59.63648-13.23776-70.02752 0-85.40416-12.35072-122.016-26.21056-154.50368-4.35072-7.65056-22.5536-30.03648-52.32768-52.09984-42.24512-31.30752-75.13984-37.88032-95.29728-37.88032H118.80832c-33.4976 0-63.85664-13.93792-85.4848-39.2448C12.4032 591.3344 0.89728 557.31072 0.92544 520.00768c0-0.6528 0.03072-1.30304 0.09216-1.952L38.848 119.2896c2.72384-36.1024 13.52704-64.6144 32.11136-84.74368C91.15648 12.67072 119.36768 1.56928 154.81344 1.55136c1.7472-0.01408 30.9824-0.24832 52.81664-0.24832 9.09696 0 21.55264 0.0448 29.22624 0.256 23.63904 0.79104 42.85952 12.70784 60.12928 25.46816 2.6624 1.95712 5.11872 3.91424 7.28576 5.64096 1.19808 0.95488 2.60864 2.08 3.89376 3.05664 1.7408-0.8384 3.65184-1.77408 5.3824-2.62144 7.46624-3.65568 17.69088-8.66304 28.87936-13.41952C369.83168 8.10624 407.70176 0.92544 441.30048 0.92544h304.91904c54.31296 0 96.68608 10.39744 125.94304 30.9056 30.21696 21.18144 46.19008 53.02144 46.19008 92.07936 0 12.39936-1.568 22.66496-5.30304 32.61952 42.9696 17.74976 67.87712 50.9248 67.87712 92.17536 0 11.42912-2.93376 27.96928-9.04704 42.32064 25.64096 18.16704 51.26656 52.37632 51.19616 89.31712 0 31.424-8.72576 57.37728-25.46688 76.33792 14.42432 21.00224 25.216 52.75136 25.216 79.41888 0 0.17024-0.00128 0.33792-0.0064 0.50688-0.83456 34.36928-17.70496 65.20576-47.50208 86.83264-28.86144 20.94592-67.63392 32.01792-112.12544 32.01792H672.60032c12.78208 45.70112 18.29888 97.10208 15.64032 147.72224-3.26528 62.16832-18.64192 117.61408-43.29728 156.1216-14.70848 22.97984-32.37504 40.07936-52.50816 50.82496-16.09856 8.59264-33.27744 12.94848-51.06048 12.94848zM42.59712 520.98432c0.16256 26.9888 8.1024 51.0208 22.40512 67.7568 13.78048 16.12544 32.38656 24.64768 53.80608 24.64768h145.7728c47.88992 0 91.74912 25.05344 120.1088 46.06976 31.86432 23.61472 56.68352 51.47776 64.73216 66.7968 0.25472 0.4864 0.49152 0.98176 0.70656 1.48608 15.15904 35.3856 29.95712 77.79712 29.95712 171.8016 0 73.37728 34.97856 81.8624 61.28896 81.8624 18.22208 0 44.89344-7.73248 68.47232-44.5696 20.82688-32.5248 33.88672-80.76672 36.77952-135.83872 2.92864-55.7632-4.94208-112.29696-22.1632-159.18848a20.8384 20.8384 0 0 1 19.5584-28.0192h219.17056c35.13216 0 66.26048-8.54912 87.64928-24.07296 19.23968-13.96224 29.71776-32.58752 30.31552-53.86752-0.10112-27.8848-16.89216-57.78944-23.77856-62.5856a20.83456 20.83456 0 0 1-1.08672-35.4496c16.66688-10.99904 25.11616-30.3488 25.11616-57.50912 0.05632-30.26688-33.29536-58.35776-44.84864-61.31072a20.83584 20.83584 0 0 1-6.81984-37.23392c3.65312-3.872 9.51936-20.58624 9.51936-33.05344 0-40.7296-42.95168-55.41248-61.41696-59.8336a20.83456 20.83456 0 0 1-12.1088-32.36224c8.59776-12.05248 10.95168-19.0592 10.95168-32.59904 0-25.58592-9.30304-44.54272-28.43904-57.95584-22.10944-15.49824-56.43648-23.35744-102.02368-23.35744h-304.9216c-31.79776 0-64.40448 7.76192-82.61504 15.45472-10.11968 4.30208-19.37408 8.83456-26.81088 12.47616-12.65664 6.19904-17.39264 8.51712-23.7696 8.51712-12.50048 0-21.69216-7.32544-29.80224-13.78688-1.96096-1.56288-3.98848-3.17824-6.04032-4.68736-11.0848-8.192-23.93472-16.9344-36.67712-17.36064-5.49504-0.15232-15.46624-0.23808-27.95392-0.23808-22.22592 0-52.25088 0.24576-52.55296 0.24832h-0.17152c-23.71328 0-41.1584 6.40896-53.3312 19.59296-12.08064 13.08416-19.20896 33.20064-21.18912 59.79136-0.01024 0.1408-0.02304 0.28032-0.03456 0.42112L42.59712 520.98432z"
              :fill="posts.commentType == 2 ? '#1296db':'#8a8a8a'" p-id="11074"></path>
            <path
              d="M301.26336 649.19296c-12.01792 0-21.76-9.74208-21.76-21.76V60.59904c0-12.01792 9.74208-21.76 21.76-21.76s21.76 9.74208 21.76 21.76v566.83392c0 12.01792-9.74208 21.76-21.76 21.76z"
              :fill="posts.commentType == 2 ? '#1296db':'#8a8a8a'" p-id="11075"></path>
          </svg>
          <span class="goodNum">{{ posts.lowNum }}</span>
        </p>
        <p style="display: flex;align-items: center;"><svg t="1708927878914" class="icon" viewBox="0 0 1024 1024"
            version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4247" width="20" height="20">
            <path
              d="M517.85728 863.9488l-124.23168-144.62976H162.14016V229.00736h711.84384v490.31168H645.24288l-127.3856 144.62976zM203.10016 678.35904h209.32608l105.84064 123.1872 108.46208-123.1872h206.29504V269.96736H203.10016v408.39168z"
              fill='#1296db' p-id="4248"></path>
            <path
              d="M293.10976 450.6624h72.97024v40.96h-72.97024zM481.5872 450.6624h72.97024v40.96h-72.97024zM670.06464 450.6624h72.97024v40.96h-72.97024z"
              fill='#1296db' p-id="4249"></path>
          </svg>{{ posts.commentNum }}</p>
        <p>{{ (posts.logWorks|| '') + '字' }}</p>
      </div>
      <div style="display: flex;align-items: center;">
        <p style="display: flex;align-items: center;">
          <svg style="cursor: pointer;margin: 0 5px 6px 0;" t="1708585254534" class="icon" viewBox="0 0 1024 1024"
            version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14860" width="16" height="16">
            <path
              d="M961.810101 530.773333c-4.046869-23.143434-13.291313-44.476768-27.500606-63.405252s-32.116364-33.758384-53.242828-44.07596c-20.130909-9.839192-42.653737-15.049697-65.11192-15.049697H668.651313c23.04-77.847273 33.82303-145.868283 32.051717-202.330505-1.499798-48.109899-12.06303-88.13899-31.379394-118.949495-32.465455-51.768889-77.963636-59.254949-79.877171-59.552323l-0.698182-0.103434h-0.711111c-29.375354 0-49.777778 8.300606-60.651313 24.656161-9.179798 13.808485-9.347879 30.034747-9.464243 40.766061-0.038788 3.025455-0.064646 5.882828-0.310303 7.576566l-0.090505 0.646464v0.659394c0 143.269495-148.984242 262.050909-213.268687 306.618182H103.511919c-24.268283 0-44.011313 19.74303-44.011313 44.011313v500.596364c0 24.268283 19.74303 44.011313 44.011313 44.011313h651.89495c17.170101 0 33.525657-5.456162 47.308283-15.786667 13.653333-10.265859 23.40202-24.332929 28.198787-40.688485l127.030303-342.199596 0.219798-0.646464c6.244848-21.57899 7.511919-44.670707 3.646061-66.75394zM97.603232 952.837172V452.253737c0-3.206465 2.702222-5.908687 5.908687-5.908686H266.395152v512.400808H103.511919c-3.206465 0-5.908687-2.702222-5.908687-5.908687z m824.216566-366.868687l-126.642424 341.152323c-0.310303 0.840404-0.594747 1.693737-0.853334 2.547071-2.495354 8.533333-7.382626 15.566869-14.506666 20.932525-7.227475 5.404444-15.450505 8.145455-24.423435 8.145455H304.497778V446.332121c7.667071-0.051717 15.140202-2.404848 21.449697-6.774949 68.809697-47.696162 228.538182-175.696162 229.66303-336.226263 0.323232-3.348687 0.36202-6.684444 0.400808-10.188283 0.064646-6.619798 0.168081-15.683232 3.10303-20.092121 2.92202-4.39596 12.774141-7.240404 26.039596-7.602424 7.059394 1.848889 32.219798 10.382222 51.885253 41.761616 15.683232 25.005253 24.281212 58.608485 25.574141 99.878788 1.64202 52.363636-8.636768 116.402424-30.500202 190.332121a38.11297 38.11297 0 0 0 5.999192 33.616162 38.111677 38.111677 0 0 0 30.526061 15.295353h147.303434c16.691717 0 33.422222 3.865859 48.381414 11.183839 15.657374 7.654141 28.948687 18.65697 39.49899 32.711111 10.576162 14.08 17.454545 29.918384 20.441212 47.075555a110.541576 110.541576 0 0 1-2.443636 48.665859z m0 0"
              p-id="14861" fill="#1296db"  ></path>
          </svg>
        </p>
        <p>{{ listPerson }}</p>
      </div>
      <div @click="showReply = true">
        <svg t="1708927878914" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
          p-id="4247" width="32" height="32">
          <path
            d="M517.85728 863.9488l-124.23168-144.62976H162.14016V229.00736h711.84384v490.31168H645.24288l-127.3856 144.62976zM203.10016 678.35904h209.32608l105.84064 123.1872 108.46208-123.1872h206.29504V269.96736H203.10016v408.39168z"
            fill="#1296db" p-id="4248"></path>
          <path
            d="M293.10976 450.6624h72.97024v40.96h-72.97024zM481.5872 450.6624h72.97024v40.96h-72.97024zM670.06464 450.6624h72.97024v40.96h-72.97024z"
            fill="#1296db" p-id="4249"></path>
        </svg>
      </div>
      <ul class="postContent">
        <li v-for="(item, index) in posts.commentList" :key="item.title" style="margin: 2px 0 0 10px;display: flex;flex-direction: column;" >
          <div class="commentContent">
            <img style="width: 40px;height: 40px; margin-right: 10px;" :src="item.commentHead" alt="">
            <div class="commentRight">
              <span>{{ item.commentName }}</span>
              <span>{{ item.commentDate }}</span>
              <div class="commentRemark">
                <span style="margin-right: 5px;">{{ (index + 1) + '楼' }}</span>
                <span>{{ item.commentTimeLong }}</span>
                {{ JSON.stringify(item.up) }}
                <span style="font-weight: bolder;color: black; margin-left: 20px;" @click="reply(item)">{{ item.commentText}}</span>
              </div>
            </div>
          </div>
          <div v-for="i in item.commentBackList" :key="i.title" style="margin: 5px 0 0 25px;">
            <div class="commentContent">
              <img style="width: 40px;height: 40px; margin-right: 10px;" :src="i.commentHead" alt="">
              <div class="commentRight">
                <span>{{ i.commentName }}</span>
                <span>{{ i.commentDate }}</span>
                <div class="commentRemark">
                  <span>{{ i.commentTimeLong }}</span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="reply-box" v-if="showReply">
        <el-input show-word-limit maxlength="500" type="textarea" v-model="replyContent"
          placeholder="说说你的看法"></el-input>
        <el-button class="sendComment" @click="submitReply">回复</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  commentItem, delCommentItem,
  getCmPageDetail
} from "@/api/doOneGood";
import moment from "moment"
export default {
  props: {
    logId: String | Number
  },
  data() {
    return {
      posts:
      {
        title: "帖子2标题1",
        replyContent: "",
        commentType: true,
        likeList: [],
        commentList: [],
      },
      // 你可以根据需要添加更多帖子数据

      goodColor: "#8a8a8a",
      noGoodColor: "#8a8a8a",
      showReply: false,
      replyContent:'',
      sendParmas:{}
    };
  },
  computed: {
    listPerson: function () {
      return this.posts.likeList.map(item => (item.commentName)).join()
    }
  },
  mounted() {
    this.getCmPageDetail({ employeeId: localStorage.getItem('employeeId'), logId: this.logId })
  },
  methods: {
    async submitReply(obj) {
      const formParams = new FormData();
        formParams.append("commentType", 0);
        formParams.append("logId", this.logId);
        formParams.append("commentDate", this.replyContent);
        formParams.append("employeeId", localStorage.getItem("employeeId"));
        formParams.append("parentId", this.sendParmas.commentId||'');
        formParams.append("receiverEmployeeId", this.sendParmas.employeeId||'');
      const {code,data} = await commentItem(formParams)
      if(code != 200) return 
      this.$message.success('评论成功')
      this.replyContent = ''
      this.showReply = false
      this.getCmPageDetail({ employeeId: localStorage.getItem('employeeId'), logId: this.logId })
    },
    // 点赞
    async clickOn(val) {
      if(val.commentType == 2) {
        this.$message.warning('您已点low')
        return
      } 
      if(!val.commentType) {
        const formParams = new FormData();
        formParams.append("commentType", 1);
        formParams.append("logId", val.logId);
        formParams.append("employeeId", localStorage.getItem("employeeId"));
        const {code,data} = await commentItem(formParams)
        if(code != 200) return
        this.getCmPageDetail({ employeeId: localStorage.getItem('employeeId'), logId: val.logId })
        return
      }
      const formParams = {
          commentType: 1,
          logId: val.logId,
          employeeId: localStorage.getItem("employeeId")
        };
        const { code, data } = await delCommentItem(formParams);
        if(code !=200) return
        this.getCmPageDetail({ employeeId: localStorage.getItem('employeeId'), logId: val.logId })

    },
    // 点Low
    async clickDown() {
      if(this.posts.commentType == 1) {
        this.$message.warning('您已点赞')
        return
      }
      if(!this.posts.commentType) {
        const formParams = new FormData();
        formParams.append("commentType", 2);
        formParams.append("logId", this.logId);
        formParams.append("employeeId", localStorage.getItem("employeeId"));
        const {code,data} = await commentItem(formParams)
        if(code != 200) return
        this.getCmPageDetail({ employeeId: localStorage.getItem('employeeId'), logId: this.logId })
        return
      }
      const formParamsDel = {
          commentType: 2,
          logId: this.logId,
          employeeId: localStorage.getItem("employeeId")
        };
        console.log(formParamsDel,'该周天之变');
        const { code, data } = await delCommentItem(formParamsDel);
        if(code !=200) return
        this.getCmPageDetail({ employeeId: localStorage.getItem('employeeId'), logId: this.logId })
    },
    goback() {
      this.$emit("update:allDetails", true);
    },
    // 评论回复
    reply(val) {
      this.sendParmas = val
      if(val.commentText === '回复') {
        this.posts.commentList.forEach(item => {
          item.commentText = '回复'
        })
        val.commentText = '收起'
        this.showReply = true
      }else {
        this.showReply = false
        val.commentText = '回复'
      }
    },
    async getCmPageDetail(params) {
      const { code, data } = await getCmPageDetail(params)
      if (code !== '200') return
      data.logTimeLong = moment(Number(data.logTimeLong+'000')).format('YYYY/MM/DD HH:mm:ss')
      data.commentList.forEach(i => {
        i.commentTimeLong = moment(Number(i.commentTimeLong+'000')).format('YYYY/MM/DD HH:mm:ss')
        i.commentText = '回复'
        i.commentBackList.forEach(v => {
          v.commentTimeLong = moment(Number(v.commentTimeLong+'000')).format('YYYY/MM/DD HH:mm:ss')
        })
      });
      this.posts = data
    }
  }
};
</script>

<style>
.post-item {
  margin: 20px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
}

.comment_footer_detail {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reply-box {
  margin-top: 10px;
}

.search {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.goodNum {
  margin: 2px 0 0 4px;
}

.postContent {
  margin-top: -16px;
  list-style-type: none;
}

.commentContent {
  display: flex;
  align-items: center;
}

.commentRight {
  display: flex;
  flex-direction: column;
  color: #8a8a8a;
  font-size: 12px;
  justify-content: center;
}

.commentRemark {
  display: flex;
  width: 230px;
  font-size: 10px;
  color: #ccc;
}

.authorTime {
  font-size: 10px;
  color: #ccc;
  margin-top: -6px;
}
.sendComment {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/OneGoodModule/GoodPostDetail.vue